import React, { useState, useEffect } from "react";
import "./FoodList.css";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "../../../../Components/Alert/Alert";
import Loading from "../../../../Components/Loading/Loading";
import { useAuth } from "../../../../AuthContext";
import Axios from "axios";
import FoodModal from "../../../../Components/FoodModal/FoodModal";
import { useLocation } from "react-router-dom";
import { useBaseUrl } from "../../../../ApiContext";

export default function FoodList() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const location = useLocation();
  const { shamsiDate, label } = location.state || {};
  const [mealData, setMealData] = useState({});
  const [activeMealId, setActiveMealId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showMealCalorieModal, setShowMealCalorieModal] = useState(false);
  const [activeUnitId, setActiveUnitId] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [mealCategoryList, setMealCategoryList] = useState([]);
  const [foodList, setFoodList] = useState([]);
  const [units, setUnits] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showNotFoundAlert, setShowNotFoundAlert] = useState(false);

  const activeMealCategoryHandler = (categoryId, categoryName) => {
    setActiveMealId(categoryId);
    setIsSearching(false);
  };

  useEffect(() => {
    const fetchActiveCategory = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/keywords/${activeMealId}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setFoodList(response.data.foods);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during active meal category request", error);
      }
    };
    if (userToken && activeMealId) {
      fetchActiveCategory();
    }
  }, [baseUrl, userToken, activeMealId]);

  const openFoodModal = (foodData) => {
    setShowMealCalorieModal(true);
    setMealData(foodData);
    const fetchFoodData = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/food_list/${foodData.id}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setUnits(response.data.units);
        setActiveUnitId(response.data.units[0].id);
      } catch (error) {
        console.log("Error during getting food data", error);
      }
    };
    if (userToken) {
      fetchFoodData();
    }
  };

  const handleHideCalorieModal = () => {
    setShowMealCalorieModal(false);
  };

  const handleActiveUnitId = (unitId) => {
    setActiveUnitId(unitId);
  };

  const saveActions = () => {
    setShowMealCalorieModal(false);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
  };

  useEffect(() => {
    const fetchFoodList = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/keywords`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setMealCategoryList(response.data.keywords);
        setActiveMealId(response.data.keywords[0].id);
      } catch (error) {
        console.log("Error during food list request", error);
      }
    };
    if (userToken) {
      fetchFoodList();
    }
  }, [baseUrl, userToken]);

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
    setIsSearching(true);
  };

  useEffect(() => {
    const fetchSeachData = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/search/${searchValue}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setSearchResults(response.data.foods);
        if (response.data.foods.length === 0) {
          setShowNotFoundAlert(true);
          setTimeout(() => {
            setShowNotFoundAlert(false);
          }, 2000);
        }
      } catch (error) {
        console.log("Error during getting food search results", error);
      }
    };

    if (searchValue !== "") {
      fetchSeachData();
    }
  }, [baseUrl, searchValue, userToken]);

  const handleCloseSearch = () => {
    setSearchValue("");
    setIsLoading(false);
  };

  return (
    <>
      <div className="mealCalorieSearchList">
        <div className="mealCalorieSearchWrapper">
          <input
            type="search"
            placeholder="لطفا خوراک مورد نظر را در اینجا جستجو کنید"
            className="mealCalorieSearch"
            value={searchValue}
            onChange={handleSearchInputChange}
          />
          <CloseIcon className="searchCloseIcon" onClick={handleCloseSearch} />
        </div>
        {isLoading ? (
          <div style={{ width: "100%", height: "50%" }}>
            <Loading />
          </div>
        ) : (
          <div className="mealCalorieList scroll centeredFlex">
            {mealCategoryList.map((category) => (
              <button
                key={category.id}
                className={`mealCalorieItem ${
                  category.id === activeMealId ? "activeMealBtn" : ""
                }`}
                onClick={() =>
                  activeMealCategoryHandler(category.id, category.name)
                }
              >
                {category.name}
              </button>
            ))}
          </div>
        )}
        <ul className="foodList scroll">
          {isSearching && searchValue
            ? searchResults.map((food) => (
                <li
                  key={food.id}
                  className="foodItem darkHorizontalBorder"
                  onClick={() => openFoodModal(food)}
                >
                  {food.name}
                </li>
              ))
            : foodList.map((food) => (
                <li
                  key={food.id}
                  className="foodItem darkHorizontalBorder"
                  onClick={() => openFoodModal(food)}
                >
                  {food.name}
                </li>
              ))}
        </ul>
      </div>
      <FoodModal
        mealData={mealData}
        show={showMealCalorieModal}
        onHideHandle={handleHideCalorieModal}
        units={units}
        activeUnitId={activeUnitId}
        onActiveUnitId={handleActiveUnitId}
        onSaveActions={saveActions}
        activeMealName={label}
        shamsiDate={shamsiDate}
        method="add"
      />
      <Alert showAlert={showAlert} alertText="ثبت شد" />
      <Alert showAlert={showNotFoundAlert} alertText="موردی یافت نشد" />
    </>
  );
}
